import {IOtpValidationForm} from "../../models/models";
// import * as yup from "yup";

// export const OTP_VALIDATION_INIT_VALUE: IOtpValidationData = {
//         name: '',
//         surname: '',
//         email: '',
//         mobile: '',
//         emailOtp: '',
//         mobileOtp: ''
// }

// Form's initial values
export const OTP_VALIDATION_DATA_FORM_INITIAL_VALUES: IOtpValidationForm = {
    mainDriver: {
        name: '',
        surname: '',
        email: '',
        mobile: '',
        emailOtp: '',
        mobileOtp: ''
    },
    additionalDrivers: [
        {
            name: '',
            surname: '',
            email: '',
            mobile: '',
            emailOtp: '',
            mobileOtp: ''
        },
        {
            name: '',
            surname: '',
            email: '',
            mobile: '',
            emailOtp: '',
            mobileOtp: ''
        }
    ]
}